export default "__VITE_ASSET__Cw0$ZpxQ__"